import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAppData } from '../store';
import { CATEGORY_LABELS, CATEGORY_EMOJI, type AssetCategory } from '../types';
import AssetForm from './AssetForm';

const CATEGORY_ORDER: AssetCategory[] = ['boat', 'car', 'property', 'apartment', 'other'];

export default function AssetList() {
  const { assets, obligations, loading } = useAppData();
  const [adding, setAdding] = useState(false);
  const navigate = useNavigate();

  if (loading) return <div className="loading-screen">Loading…</div>;

  const byCategory = CATEGORY_ORDER.map((category) => ({
    category,
    assets: assets.filter((a) => a.category === category),
  })).filter((g) => g.assets.length > 0);

  return (
    <div className="asset-list">
      <div className="page-header">
        <h1>Assets</h1>
        <button className="btn-primary" onClick={() => setAdding(true)}>
          + Add asset
        </button>
      </div>

      {adding && (
        <AssetForm
          onCancel={() => setAdding(false)}
          onDone={(asset) => {
            setAdding(false);
            navigate(`/assets/${asset.id}`);
          }}
        />
      )}

      {assets.length === 0 && !adding && (
        <p className="muted empty">
          No assets yet. Add your boats, cars, properties, or anything else you want to keep
          track of.
        </p>
      )}

      {byCategory.map(({ category, assets: group }) => (
        <section key={category} className="asset-category">
          <h2>
            {CATEGORY_EMOJI[category]} {CATEGORY_LABELS[category]}
          </h2>
          <div className="card-list">
            {group.map((asset) => {
              const count = obligations.filter((o) => o.asset_id === asset.id && o.active).length;
              return (
                <Link key={asset.id} to={`/assets/${asset.id}`} className="card asset-card">
                  <div className="asset-card-title">{asset.name}</div>
                  <div className="muted">
                    {count} obligation{count === 1 ? '' : 's'}
                  </div>
                </Link>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}
